import CmBrand from './cm-brand.entity';
import { SosListResponse } from '../sos-response';

export interface CmBrandListResponse extends SosListResponse {
	listed: {
		CmBrand: CmBrand[];
	};
}
